import React from 'react';
import Label from 'components/_utility/Label';
import { Wrap, Title, Description } from './NoResults.styled';

const NoResults = () => (
  <Wrap>
    <Title>
      <Label name="noResultsTitle"></Label>
    </Title>
    <Description>
      <Label name="noResultsText"></Label>
    </Description>
  </Wrap>
);

export default NoResults;
